export default __webpack_public_path__ + "static/media/sort-down.94471255.svg";